import { FaPaw } from "react-icons/fa";

const ITEMS = [
  "100% FLUFF",
  "PAW APPROVED",
  "TARKOV TIME",
  "AWOO!",
  "CHAOS CERTIFIED",
  "CERTIFIED GOOD BOY",
  "HUSKO.EXE IS RUNNING",
  "ZOOMIES SCHEDULED",
  "VRCHAT HANGOUTS",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-gradient-to-r from-husko-cyan/10 via-husko-purple/10 to-husko-magenta/10 py-4"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap will-change-transform">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {ITEMS.map((item) => (
              <span
                key={`${copy}-${item}`}
                className="flex items-center font-display text-xl font-extrabold uppercase tracking-tight text-slate-100 md:text-2xl"
              >
                <span className="px-6">{item}</span>
                <FaPaw className="shrink-0 text-husko-cyan" size={18} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
